module.exports = __webpack_public_path__ + "static/media/13.02db2043.jpg";